import { Box, Grid, Heading, Stack } from '@chakra-ui/react';

import { Service } from '../../../types/service.type';

import ServiceCard from './service-card';

export default function ServicesGrid({
    services,
    onUpdateService,
}: {
    services: Service[];
    onUpdateService: (service: Service) => void;
}) {
    return (
        <Box p={6}>
            <Grid
                templateColumns={{
                    base: 'repeat(1, 1fr)',
                    md: 'repeat(3, 1fr)',
                }}
                gap={5}
            >
                {services.map((service) => (
                    <ServiceCard
                        key={service.id}
                        service={service}
                        onUpdate={onUpdateService}
                    />
                ))}
            </Grid>

            {!services.length ? (
                <Heading textAlign="center" size="md">
                    No hay servicios disponibles
                </Heading>
            ) : (
                <Stack
                    direction={{ base: 'column', md: 'row' }}
                    spacing={6}
                    align="center"
                    justify="center"
                    wrap="wrap"
                ></Stack>
            )}
        </Box>
    );
}
